import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
const EditEmployee = (params) => {
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div className="row top-logos align-items-center">
              <div className="col-md-6">
                <figure className="uploaded-logo mx-0">
                  <span className="imagediv">
                    <img
                      src="https://uat.gogmgo.com/employee_images/1642043986.png"
                      id="mlogo"
                    />
                  </span>
                </figure>
                <div className="col-6 d-flex align-content-center flex-wrap">
                  <h4 class="mb-0"> Mario Lopez</h4>
                  <span className="upload-logo uploadlogo mt-0">
                    Upload Photo
                  </span>
                </div>
              </div>

              <div class="col-md-6 align-right">
                <a
                  href="/labor_settings/leave_request/employeeId:881"
                  class="btn bordered-btn"
                >
                  Leave Request
                </a>{" "}
                <a
                  href="/labor_settings/medical_claim/employeeId:881"
                  class="btn bordered-btn"
                >
                  Medical Claim
                </a>{" "}
              </div>
            </div>
            <div className="row">
              <div className="tab-section">
                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                  <button
                    className="nav-link active"
                    id="nav-home-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-home"
                    type="button"
                    role="tab"
                    aria-controls="nav-home"
                    aria-selected="true"
                  >
                    Info
                  </button>
                  <button
                    className="nav-link"
                    id="nav-profile-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-profile"
                    type="button"
                    role="tab"
                    aria-controls="nav-profile"
                    aria-selected="false"
                  >
                    Payroll
                  </button>
                  <button
                    className="nav-link"
                    id="nav-contact-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-contact"
                    type="button"
                    role="tab"
                    aria-controls="nav-contact"
                    aria-selected="false"
                  >
                    Career
                  </button>

                  <button
                    className="nav-link"
                    id="nav-mastersetting-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-mastersetting"
                    type="button"
                    role="tab"
                    aria-controls="nav-mastersetting"
                    aria-selected="false"
                  >
                    History
                  </button>
                </div>
              </div>
            </div>
            <div className="tab-content" id="nav-tabContent">
              <div
                className="tab-pane fade show active"
                id="nav-home"
                role="tabpanel"
                aria-labelledby="nav-home-tab"
              >
                <div className="row">
                  <div className="container px-0">
                    <div className="row employeeSettingSec mt-4 d-flex">
                      <div className="col-md-8">
                        <div className="shadowclass mt-0 d-flex h-100 flex-wrap align-content-start">
                          <h4 className="event-alert w-100">
                            Employee Details
                            <span className="green_tag active-tag">
                              {" "}
                              Active{" "}
                            </span>
                          </h4>
                          <div className="d-flex calc-height">
                            <div className="settings-left-content fixed-pos">
                              <ul className="settingMenus">
                                <li id="AccDetail_li" className="active">
                                  <a href="#_" id="AccDetail_dayTime_a">
                                    Personal <br />
                                    Details
                                  </a>
                                </li>
                                <li id="Address_li" className="">
                                  <a href="#_" id="Address_dayTime_a">
                                    Address
                                  </a>
                                </li>
                                <li id="FinSettings_li" className="">
                                  <a href="#_" id="FinSettings_dayTime_a">
                                    Contact Details
                                  </a>
                                </li>
                                <li id="FinSettings_li" className="">
                                  <a href="#_" id="FinSettings_dayTime_a">
                                    Job Info
                                  </a>
                                </li>
                                <li id="FinSettings_li" className="">
                                  <a href="#_" id="FinSettings_dayTime_a">
                                    Work Permit &amp; <br /> Education Info
                                  </a>
                                </li>
                                <li id="FinSettings_li" className="">
                                  <a href="#_" id="FinSettings_dayTime_a">
                                    Children &amp; <br />
                                    Dependents
                                  </a>
                                </li>
                                <li id="FinSettings_li" className="">
                                  <a href="#_" id="FinSettings_dayTime_a">
                                    Emergency <br />
                                    Contact Info
                                  </a>
                                </li>
                              </ul>
                            </div>

                            <div className="settings-right-content scrolling">
                              <div className="date-sec-scroll">
                                <div
                                  id="AccDetail_dayTime_div"
                                  className="row-fluid scroll-change full_div"
                                  day_time="AccDetail"
                                >
                                  <div className="form-secs">
                                    <h4> Personal Details</h4>

                                    <ul class="ingredient-info edit-shift">
                                      <li>
                                        <label class="required">Account</label>
                                        <div class="input-group select-div">
                                          <select
                                            name="data[Employee][merchant_id]"
                                            required="required"
                                            class="merchant_id"
                                            id="EmployeeMerchantId"
                                          >
                                            <option value="">Select</option>
                                            <option value="375">
                                              Harry's HQ
                                            </option>
                                            <option value="377">
                                              Boat Quay Pilot
                                            </option>
                                            <option value="384">
                                              Harry's Clarke Quay Pilot
                                            </option>
                                          </select>{" "}
                                        </div>
                                      </li>
                                      <li>
                                        <label class="required">Status</label>
                                        <div class="input-group select-div">
                                          <select
                                            name="data[Employee][employment_status_id]"
                                            class="get_rules status_dd"
                                            required="required"
                                            id="EmployeeEmploymentStatusId"
                                          >
                                            <option value="">Select</option>
                                            <option value="1">Full Time</option>
                                            <option value="2">Part Time</option>
                                            <option value="3">
                                              Contractor
                                            </option>
                                          </select>{" "}
                                        </div>
                                      </li>
                                      <li>
                                        <label class="required">
                                          First Name
                                        </label>
                                        <div class="input-group">
                                          <input
                                            name="data[Employee][employee_name]"
                                            class="get_rules emp_name"
                                            required="required"
                                            maxlength="50"
                                            type="text"
                                            id="EmployeeEmployeeName"
                                          />{" "}
                                        </div>
                                      </li>
                                      <li>
                                        <label class="required">
                                          Last Name
                                        </label>
                                        <div class="input-group">
                                          <input
                                            name="data[Employee][last_name]"
                                            class="get_rules emp_name"
                                            required="required"
                                            maxlength="50"
                                            type="text"
                                            id="EmployeeLastName"
                                          />{" "}
                                        </div>
                                      </li>
                                      <li>
                                        <label class="required">Nickname</label>
                                        <div class="input-group">
                                          <input
                                            name="data[Employee][nickname]"
                                            required="required"
                                            maxlength="50"
                                            type="text"
                                            id="EmployeeNickname"
                                          />{" "}
                                        </div>
                                      </li>
                                      <li class="half">
                                        <label>Race</label>
                                        <div class="input-group">
                                          <select
                                            name="data[Employee][race]"
                                            id="EmployeeRace"
                                          >
                                            <option value="">Select</option>
                                            <option value="1">Chinese</option>
                                            <option value="2">Indian</option>
                                            <option value="3">Malay</option>
                                            <option value="4">Eurasian</option>
                                            <option value="5">Other</option>
                                          </select>{" "}
                                        </div>
                                      </li>
                                      <li class="half">
                                        <label>Religion</label>
                                        <div class="input-group">
                                          <select
                                            name="data[Employee][religion]"
                                            id="EmployeeReligion"
                                          >
                                            <option value="">Select</option>
                                            <option value="1">Muslim</option>
                                            <option value="2">Christian</option>
                                            <option value="3">Taoist</option>
                                            <option value="4">Buddhist</option>
                                            <option value="5">Hindu</option>
                                            <option value="6">Sikh</option>
                                            <option value="7">Jewish</option>
                                            <option value="8">Other</option>
                                            <option value="9">None</option>
                                          </select>{" "}
                                        </div>
                                      </li>
                                      <li>
                                        <label class="required">
                                          ID # / Passport #
                                        </label>
                                        <div class="input-group">
                                          <input
                                            name="data[Employee][identification_pin]"
                                            required="required"
                                            maxlength="50"
                                            type="text"
                                            id="EmployeeIdentificationPin"
                                          />{" "}
                                        </div>
                                      </li>
                                      <li>
                                        <label class="required">
                                          Date of Birth
                                        </label>
                                        <div class="span7 input-group bootstrap-timepicker date-input datepickerDob date">
                                          <span class="add-on pull-right other-income-addon">
                                            <i class="fa fa-calendar"></i>
                                          </span>
                                          <input
                                            name="data[Employee][dob]"
                                            class="input-small readonly"
                                            required="required"
                                            type="text"
                                            id="EmployeeDob"
                                          />{" "}
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                </div>

                                <div
                                  id="Address_dayTime_div"
                                  className="row-fluid scroll-change full_div"
                                  day_time="Address"
                                >
                                  <div className="form-secs">
                                    <h4> Address </h4>
                                    <ul class="ingredient-info edit-shift d-flex">
                                      <li>
                                        <label class="required">
                                          Address Line #1
                                        </label>
                                        <div class="input-group textarea-sec">
                                          <textarea
                                            name="data[Employee][address_line_1]"
                                            class="valid"
                                            required="required"
                                            cols="30"
                                            rows="6"
                                            id="EmployeeAddressLine1"
                                          ></textarea>{" "}
                                        </div>
                                      </li>
                                      <li>
                                        <label class="">Address Line #2</label>
                                        <div class="input-group textarea-sec">
                                          <textarea
                                            name="data[Employee][address_line_2]"
                                            class="valid"
                                            cols="30"
                                            rows="6"
                                            id="EmployeeAddressLine2"
                                          ></textarea>{" "}
                                        </div>
                                      </li>

                                      <li class="half">
                                        <label class="required">City</label>
                                        <div
                                          class="input-group span7"
                                          id="city_div"
                                        >
                                          <input
                                            name="data[Employee][city_id]"
                                            class="valid"
                                            required="required"
                                            type="text"
                                            id="EmployeeCityId"
                                          />{" "}
                                        </div>
                                      </li>

                                      <li class="half">
                                        <label class="required">State</label>
                                        <div class="input-group select-div ">
                                          <select
                                            name="data[Employee][state_id]"
                                            required="required"
                                            id="EmployeeStateId"
                                          >
                                            <option value="">
                                              Select State
                                            </option>
                                          </select>{" "}
                                        </div>
                                      </li>

                                      <li class="half">
                                        <label class="required">Country</label>
                                        <div class="input-group select-div ">
                                          <select
                                            name="data[Employee][country_id]"
                                            required="required"
                                            id="EmployeeCountryId"
                                          >
                                            <option value="">
                                              Select Country
                                            </option>
                                            <option value="5">India</option>
                                            <option value="3">Indonesia</option>
                                            <option value="2">Malaysia</option>
                                            <option value="1">Singapore</option>
                                          </select>{" "}
                                        </div>
                                      </li>

                                      <li class="half">
                                        <label class="required">Zip Code</label>
                                        <div class="input-group span7">
                                          <input
                                            name="data[Employee][zip_code]"
                                            class="valid"
                                            type="number"
                                            id="EmployeeZipCode"
                                          />{" "}
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                </div>

                                <div
                                  id="FinSettings_dayTime_div"
                                  className="row-fluid scroll-change full_div"
                                  day_time="FinSettings"
                                >
                                  <div className="form-secs">
                                    <h4> Contact Details</h4>
                                    <ul class="ingredient-info edit-shift">
                                      <li>
                                        <label class="required">
                                          Contact{" "}
                                          <span class="hide-lap">Number</span>{" "}
                                          <span class="show-lap">No.</span> #1
                                        </label>
                                        <div class="input-group">
                                          <input
                                            name="data[Employee][contact_number_1]"
                                            required="required"
                                            onkeypress="if(this.value.length==15) return false;"
                                            pattern="[0-9]{6,15}"
                                            title="Please enter valid contact number"
                                            maxlength="50"
                                            type="text"
                                            id="EmployeeContactNumber1"
                                          />{" "}
                                        </div>
                                      </li>
                                      <li>
                                        <label class="">
                                          Contact{" "}
                                          <span class="hide-lap">Number</span>{" "}
                                          <span class="show-lap">No.</span> #2
                                        </label>
                                        <div class="input-group">
                                          <input
                                            name="data[Employee][contact_number_2]"
                                            onkeypress="if(this.value.length==15) return false;"
                                            pattern="[0-9]{6,15}"
                                            title="Please enter valid contact number"
                                            maxlength="50"
                                            type="text"
                                            id="EmployeeContactNumber2"
                                          />{" "}
                                        </div>
                                      </li>
                                      <li>
                                        <label class="required">Email</label>
                                        <div class="input-group">
                                          <input
                                            name="data[Employee][email]"
                                            class="email"
                                            required="required"
                                            type="email"
                                            id="EmployeeEmail"
                                          />{" "}
                                        </div>
                                      </li>
                                      <li>
                                        <label class="required">
                                          Contact Preference
                                        </label>
                                        <div class="input-group select-div">
                                          <select
                                            name="data[Employee][contact_preference_id]"
                                            required="required"
                                            id="EmployeeContactPreferenceId"
                                          >
                                            <option value="">
                                              Select Contact Preference
                                            </option>
                                            <option value="1">
                                              Contact Number #1
                                            </option>
                                            <option value="2">
                                              Contact Number #2
                                            </option>
                                            <option value="3">Email</option>
                                          </select>{" "}
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                </div>

                                <div
                                  id="FinSettings_dayTime_div"
                                  className="row-fluid scroll-change full_div"
                                  day_time="FinSettings"
                                >
                                  <div className="form-secs">
                                    <h4> Job Info</h4>
                                    <ul class="ingredient-info edit-shift d-flex">
                                      <li class="half">
                                        <label class="required">Function</label>
                                        <div class="input-group select-div ">
                                          <select
                                            name="data[Employee][employee_function_id]"
                                            class="get_rules function_dd"
                                            required="required"
                                            id="EmployeeEmployeeFunctionId"
                                          >
                                            <option value="">Select</option>
                                            <option value="1">
                                              Management
                                            </option>
                                            <option value="2">Host</option>
                                            <option value="3">Kitchen</option>
                                            <option value="4">Service</option>
                                            <option value="5">Delivery</option>
                                          </select>{" "}
                                        </div>
                                      </li>
                                      <li class="half">
                                        <label class="required">
                                          Role Title
                                        </label>
                                        <div class="input-group">
                                          <input
                                            name="data[Employee][role_title]"
                                            required="required"
                                            maxlength="50"
                                            type="text"
                                            id="EmployeeRoleTitle"
                                          />{" "}
                                        </div>
                                      </li>
                                      <li>
                                        <label>Category</label>
                                        <div class="input-group select-div ">
                                          <select
                                            name="data[Employee][employee_category_id]"
                                            class="get_rules category_dd"
                                            id="EmployeeEmployeeCategoryId"
                                          >
                                            <option value="">Select</option>
                                            <option value="1">
                                              New Category
                                            </option>
                                          </select>{" "}
                                        </div>
                                      </li>
                                      <li class="half">
                                        <label>Work Week Type</label>
                                        <div class="input-group select-div ">
                                          <select
                                            name="data[Employee][work_week_type]"
                                            class="required"
                                            id="EmployeeWorkWeekType"
                                          >
                                            <option value="">Select</option>
                                            <option value="1">
                                              5-Day Work Week
                                            </option>
                                            <option value="2">
                                              5.5-Day Work Week
                                            </option>
                                            <option value="3">
                                              6-Day Work Week
                                            </option>
                                          </select>{" "}
                                        </div>
                                      </li>
                                      <li class="half">
                                        <label>Rosterable?</label>
                                        <div class="input-group select-div ">
                                          <select
                                            name="data[Employee][rosterable]"
                                            class="required"
                                            id="EmployeeRosterable"
                                          >
                                            <option value="">Select</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                          </select>{" "}
                                        </div>
                                      </li>
                                      <li class="half">
                                        <label class="required">
                                          Start Date
                                        </label>
                                        <div class="span7 input-group  bootstrap-timepicker date-input datepicker2 date">
                                          <span class="add-on pull-right other-income-addon">
                                            <i class="fa fa-calendar"></i>
                                          </span>
                                          <input
                                            name="data[Employee][start_date]"
                                            class="valid input-datepicker-otherincome"
                                            readonly="readonly"
                                            value="2022-05-09"
                                            required="required"
                                            type="text"
                                            id="EmployeeStartDate"
                                          />{" "}
                                        </div>
                                      </li>
                                      <li class="half">
                                        <label>End Date</label>
                                        <div class="span7 input-group">
                                          <span class="add-on pull-right other-income-addon">
                                            <i class="fa fa-calendar"></i>
                                          </span>
                                          <input
                                            name="data[Employee][end_date]"
                                            class="valid input-datepicker-otherincome"
                                            readonly="readonly"
                                            type="text"
                                            id="EmployeeEndDate"
                                          />{" "}
                                        </div>
                                      </li>
                                      <li>
                                        <label class="required">
                                          Account Approving Manager
                                        </label>
                                        <div class="input-group select-div ">
                                          <select
                                            name="data[Employee][account_approving_manager]"
                                            required="required"
                                            id="EmployeeAccountApprovingManager"
                                          >
                                            <option value="">Select</option>
                                            <option value="Yes">Yes</option>
                                            <option
                                              value="No"
                                              selected="selected"
                                            >
                                              No
                                            </option>
                                          </select>{" "}
                                        </div>
                                      </li>

                                      <li>
                                        <label>Approving Manager</label>
                                        <div class="input-group select-div ">
                                          <select
                                            name="data[Employee][approving_manager]"
                                            id="EmployeeApprovingManager"
                                          >
                                            <option value="">Select</option>
                                            <option value="Account Approving Manager">
                                              Account Approving Manager
                                            </option>
                                            <option value="Cluster Manager">
                                              Cluster Manager
                                            </option>
                                            <option value="Group HR Manager">
                                              Group HR Manager
                                            </option>
                                          </select>{" "}
                                        </div>
                                      </li>

                                      <li class="half">
                                        <label>Confirmation Date</label>
                                        <div class="span7 input-group  bootstrap-timepicker date-input datepicker2 date">
                                          <span class="add-on pull-right other-income-addon">
                                            <i class="fa fa-calendar"></i>
                                          </span>
                                          <input
                                            name="data[Employee][confirmation_date]"
                                            class="valid input-datepicker-otherincome"
                                            readonly="readonly"
                                            type="text"
                                            id="EmployeeConfirmationDate"
                                          />{" "}
                                        </div>
                                      </li>
                                      <li class="half">
                                        <label>Confirmation Status</label>
                                        <div class="input-group select-div ">
                                          <select
                                            name="data[Employee][confirmation_status]"
                                            id="EmployeeConfirmationStatus"
                                          >
                                            <option value="">Select</option>
                                            <option value="confirmed">
                                              Confirmed
                                            </option>
                                            <option value="pending">
                                              Pending
                                            </option>
                                          </select>{" "}
                                        </div>
                                      </li>
                                      <li>
                                        <label>Confirmed By</label>
                                        <div class="input-group ">
                                          <input
                                            name="data[Employee][confirmed_by]"
                                            type="text"
                                            id="EmployeeConfirmedBy"
                                          />{" "}
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                </div>

                                <div
                                  id="FinSettings_dayTime_div"
                                  className="row-fluid scroll-change full_div"
                                  day_time="FinSettings"
                                >
                                  <div className="form-secs">
                                    <h4> Work Permit</h4>
                                    <ul class="ingredient-info edit-shift d-flex">
                                      <li>
                                        <label class="required">
                                          Work Permit Type
                                        </label>
                                        <div class="input-group select-div ">
                                          <select
                                            name="data[Employee][work_permit_type]"
                                            required="required"
                                            id="EmployeeWorkPermitType"
                                          >
                                            <option value="">Select</option>
                                            <option value="1">Citizen</option>
                                            <option value="2">PR3</option>
                                            <option value="3">PR2</option>
                                            <option value="4">PR1</option>
                                            <option value="5">EP</option>
                                            <option value="6">SP</option>
                                            <option value="7">WP</option>
                                          </select>{" "}
                                        </div>
                                      </li>
                                      <li class="half">
                                        <label> Effective Date </label>
                                        <div class="span7 input-group  bootstrap-timepicker date-input datepicker2 date">
                                          <span class="add-on pull-right other-income-addon">
                                            <i class="fa fa-calendar"></i>
                                          </span>
                                          <input
                                            name="data[Employee][permit_effective_date]"
                                            class="valid input-datepicker-otherincome"
                                            readonly="readonly"
                                            type="text"
                                            id="EmployeePermitEffectiveDate"
                                          />{" "}
                                        </div>
                                      </li>
                                      <li class="half">
                                        <label> Expiry Date </label>
                                        <div class="span7 input-group  bootstrap-timepicker date-input datepicker2 date">
                                          <span class="add-on pull-right other-income-addon">
                                            <i class="fa fa-calendar"></i>
                                          </span>
                                          <input
                                            name="data[Employee][permit_expiry_date]"
                                            class="valid input-datepicker-otherincome"
                                            readonly="readonly"
                                            type="text"
                                            id="EmployeePermitExpiryDate"
                                          />{" "}
                                        </div>
                                      </li>
                                      <li class="half">
                                        <label class="required">
                                          Education Level
                                        </label>
                                        <div class="input-group select-div ">
                                          <select
                                            name="data[Employee][education_level]"
                                            required="required"
                                            id="EmployeeEducationLevel"
                                          >
                                            <option value="">Select</option>
                                            <option value="1">
                                              Pre-primary
                                            </option>
                                            <option value="2">Primary</option>
                                            <option value="3">Secondary</option>
                                            <option value="4">
                                              Post-Secondary (Non-Tertiary)
                                            </option>
                                            <option value="5">
                                              Diploma Courses
                                            </option>
                                            <option value="6">
                                              University
                                            </option>
                                          </select>{" "}
                                        </div>
                                      </li>
                                      <li class="half">
                                        <label>Highest Institution Name</label>
                                        <div class="input-group">
                                          <input
                                            name="data[Employee][institution_name]"
                                            type="text"
                                            id="EmployeeInstitutionName"
                                          />{" "}
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                </div>

                                <div
                                  id="FinSettings_dayTime_div"
                                  className="row-fluid scroll-change full_div"
                                  day_time="FinSettings"
                                >
                                  <div className="form-secs">
                                    <h4> Children &amp; Dependents</h4>
                                    <ul class="ingredient-info edit-shift d-flex">
                                      <li>
                                        <table
                                          id="Dependents"
                                          class="checklist-table remove-space aviTable"
                                          cellspacing="0"
                                          cellpadding="0"
                                          width="100%"
                                        >
                                          <thead>
                                            <tr>
                                              <th></th>
                                              <th>Name &amp; Relationship</th>
                                              <th>DOB</th>
                                              <th>ID Number</th>
                                            </tr>
                                          </thead>
                                          <tbody id="ChildrenDependent"></tbody>
                                        </table>

                                        <div class="my-3">
                                          <a
                                            id="addDependents"
                                            class="btn green-btn-revert add-plus"
                                            href="#_"
                                          >
                                            <i class="i-icon"> </i> Add
                                            Dependent{" "}
                                          </a>
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                </div>

                                <div
                                  id="FinSettings_dayTime_div"
                                  className="row-fluid scroll-change full_div"
                                  day_time="FinSettings"
                                >
                                  <div className="form-secs">
                                    <h4> Emergency Contact Info </h4>
                                    <ul class="ingredient-info edit-shift d-flex">
                                      <li class="half">
                                        <label class="required">
                                          {" "}
                                          Contact Name{" "}
                                        </label>
                                        <div class="input-group">
                                          <input
                                            name="data[Employee][emergency_contact_name]"
                                            required="required"
                                            maxlength="80"
                                            type="text"
                                            id="EmployeeEmergencyContactName"
                                          />{" "}
                                        </div>
                                      </li>
                                      <li class="half">
                                        <label class="required">
                                          {" "}
                                          Relationship{" "}
                                        </label>
                                        <div class="input-group">
                                          <input
                                            name="data[Employee][relationship]"
                                            required="required"
                                            maxlength="80"
                                            type="text"
                                            id="EmployeeRelationship"
                                          />{" "}
                                        </div>
                                      </li>
                                      <li class="half">
                                        <label class="required">
                                          {" "}
                                          Contact{" "}
                                          <span class="hide-lap">
                                            Number
                                          </span>{" "}
                                          <span class="show-lap">No.</span>{" "}
                                        </label>
                                        <div class="input-group">
                                          <input
                                            name="data[Employee][emergency_contact_number]"
                                            onkeypress="if(this.value.length==15) return false;"
                                            pattern="[0-9]{6,15}"
                                            title="Please enter valid contact number"
                                            required="required"
                                            maxlength="20"
                                            type="text"
                                            id="EmployeeEmergencyContactNumber"
                                          />{" "}
                                        </div>
                                      </li>
                                      <li class="half">
                                        <label class=""> Contact Email </label>
                                        <div class="input-group">
                                          <input
                                            name="data[Employee][emergency_contact_email]"
                                            class="email"
                                            type="email"
                                            id="EmployeeEmergencyContactEmail"
                                          />{" "}
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4 timeSetting operatingDaysMs pay-performance">
                        <div className="shadowclass mt-0 d-flex h-100 flex-wrap align-content-start">
                          <h4 className="event-alert w-100">
                            Pay, Benefits, &amp; Taxes
                          </h4>
                          <ul class="ingredient-info payPerform">
                            <li>
                              <label class="required">Filing Status</label>
                              <div class="input-group select-div mb10">
                                <select
                                  name="data[Employee][filing_status_id]"
                                  required="required"
                                  id="EmployeeFilingStatusId"
                                >
                                  <option value="">Select Filing Status</option>
                                  <option value="1">Single</option>
                                  <option value="2">Married-Joint</option>
                                  <option value="3">Married-Separate</option>
                                  <option value="4">Head of Household</option>
                                  <option value="5">
                                    Widowed with dependants
                                  </option>
                                </select>{" "}
                              </div>
                            </li>
                            <li>
                              <label class="required">Dependents</label>
                              <div class="input-group select-div mb10">
                                <select
                                  name="data[Employee][allowance_id]"
                                  required="required"
                                  id="EmployeeAllowanceId"
                                >
                                  <option value="">
                                    Select Allowance Amount
                                  </option>
                                  <option value="0">0</option>
                                  <option value="1">1</option>
                                  <option value="2">2</option>
                                  <option value="3">3</option>
                                  <option value="4">4</option>
                                  <option value="5">5</option>
                                  <option value="6">6</option>
                                  <option value="7">7</option>
                                  <option value="8">8</option>
                                  <option value="9">9</option>
                                  <option value="10">10</option>
                                  <option value="11">11</option>
                                  <option value="12">12</option>
                                </select>{" "}
                              </div>
                            </li>
                            <li>
                              <label class="required" id="salaryLabel">
                                Annual Salary
                              </label>
                              <div class="input-group">
                                <span class="dolor-sign"> $</span>
                                <input
                                  name="data[Employee][annual_salary]"
                                  class="currency"
                                  required="required"
                                  type="text"
                                  id="EmployeeAnnualSalary"
                                />{" "}
                              </div>
                            </li>
                            <li>
                              <label class="required">Applicable Payroll</label>
                              <div class="input-group">
                                <select
                                  name="data[Employee][payroll_frequency_id]"
                                  class=""
                                  required="required"
                                  id="EmployeePayrollFrequencyId"
                                >
                                  <option value="">Select</option>
                                  <option value="123">
                                    Monthly FT Payroll
                                  </option>
                                </select>{" "}
                              </div>
                            </li>
                            <li>
                              <label>
                                {" "}
                                Applicable Weekly Overtime{" "}
                                <span class="hide-small">Rule</span>
                              </label>
                              <div class="input-group">
                                <input
                                  name="data[Employee][overtime_rule_weekly_name]"
                                  id="overtime_rule_w"
                                  placeholder="Select Weekly Rule"
                                  type="text"
                                  disabled="disabled"
                                />{" "}
                              </div>
                              <input
                                type="hidden"
                                name="data[Employee][overtime_weekly_rule_id]"
                                id="EmployeeOvertimeWeeklyRuleId"
                              />
                            </li>
                            <li>
                              <label>
                                {" "}
                                Applicable Daily Overtime{" "}
                                <span class="hide-small">Rule</span>
                              </label>
                              <div class="input-group">
                                <input
                                  name="data[Employee][overtime_rule_daily_name]"
                                  id="overtime_rule"
                                  placeholder="Select Daily Rule"
                                  type="text"
                                  disabled="disabled"
                                />{" "}
                              </div>
                              <input
                                type="hidden"
                                name="data[Employee][overtime_rule_id]"
                                id="EmployeeOvertimeRuleId"
                              />{" "}
                            </li>
                            <li>
                              <label>
                                {" "}
                                Applicable Public Holiday{" "}
                                <span class="hide-small">Rule</span>
                              </label>
                              <div class="input-group">
                                <input
                                  name="data[Employee][public_holiday_rule_name]"
                                  id="overtime_rule_public_holiday"
                                  placeholder="Select Public Holiday Rule"
                                  type="text"
                                  disabled="disabled"
                                />{" "}
                              </div>
                              <input
                                type="hidden"
                                name="data[Employee][public_holiday_rule_id]"
                                id="EmployeePublicHolidayRuleId"
                              />{" "}
                            </li>
                            <li>
                              <label>
                                Applicable Allowance{" "}
                                <span class="hide-small">Rule</span>
                              </label>
                              <div class="input-group">
                                <input
                                  name="data[Employee][meal_allowance_rule_name]"
                                  id="meal_allowance_rule"
                                  placeholder="Select Meal Allowance Rule"
                                  type="text"
                                  disabled="disabled"
                                />{" "}
                              </div>
                              <input
                                type="hidden"
                                name="data[Employee][meal_allowance_rule_id]"
                                id="EmployeeMealAllowanceRuleId"
                              />{" "}
                            </li>
                            <li>
                              <label>Time Period</label>
                              <div class="input-group select-div mb10">
                                <select
                                  name="data[Employee][pa_time_period_id]"
                                  id="EmployeePaTimePeriodId"
                                >
                                  <option value="">Select Time Period</option>
                                  <option value="1">Week-to-Date</option>
                                  <option value="2">7 Calendar Days</option>
                                  <option value="3">Month-to-Date</option>
                                  <option value="4">30 Calendar Days</option>
                                  <option value="5">Quarter-to-Date</option>
                                  <option value="6">90 Calendar Days</option>
                                  <option value="7">1 Calendar Year</option>
                                  <option value="8" selected="selected">
                                    Year-to-Date
                                  </option>
                                </select>{" "}
                              </div>
                            </li>
                            <li>
                              <label>Tax Documents</label>
                              <div class="inner-space screen-scroll mCS_destroyed">
                                <table
                                  id="TableDable"
                                  class="checklist-table remove-space aviTable"
                                  cellspacing="0"
                                  cellpadding="0"
                                  width="100%"
                                >
                                  <tbody id="taxDocumentIndex"></tbody>
                                </table>
                                <div class="my-3">
                                  <a
                                    id="addTaxDocument"
                                    class="btn green-btn-revert add-plus"
                                    href="#_"
                                  >
                                    <i class="i-icon"> </i> Add Document{" "}
                                  </a>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="row employeeSettingSec d-flex">
                      <div className="col-md-8 d-flex">
                        <div class="shadowclass mt-0">
                          <h4 class="event-alert">Leave / Medical Allowance</h4>
                          <div class="inner-space screen-scroll">
                            <table
                              width="100%"
                              cellspacing="0"
                              cellpadding="0"
                              class="checklist-table remove-space inventory_table"
                            >
                              <thead>
                                <tr>
                                  <th>
                                    <a href="#_" class="">
                                      {" "}
                                      Leave Type{" "}
                                    </a>
                                  </th>
                                  <th> Leave Name </th>
                                  <th> Alloted </th>
                                  <th> Accrued </th>
                                  <th> Used </th>
                                  <th> Remaining </th>
                                  <th> Pending </th>
                                  <th> </th>
                                  <th> Actions </th>
                                </tr>
                              </thead>
                              <tbody id="leaveTbody"></tbody>
                            </table>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-4 timeSetting d-flex">
                        <div className="shadowclass mt-0">
                          <h4 className="event-alert">
                            Operating Days &amp; Hours
                          </h4>
                          <div className="inner-space screen-scroll mCS_destroyed">
                            <table className="checklist-table remove-space aviTable">
                              <thead>
                                <tr>
                                  <th width="15">&nbsp;</th>
                                  <th>Day</th>
                                  <th>From</th>
                                  <th>To</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td width="15">
                                    <input
                                      type="hidden"
                                      name="data[0][MerchantScheduledDay][id]"
                                      value="1797"
                                    />
                                    <div className="checkbox avaiCheck">
                                      <input
                                        type="hidden"
                                        name="data[0][MerchantScheduledDay][weekday]"
                                        id="MerchantScheduledDaymonday_"
                                        value="monday"
                                      />
                                      <input
                                        type="checkbox"
                                        name="data[0][MerchantScheduledDay][weekday]"
                                        className="avail_checkbox"
                                        checked=""
                                        value="monday"
                                        id="MerchantScheduledDaymonday"
                                      />
                                      <label for="MerchantScheduledDaymonday"></label>
                                    </div>
                                  </td>
                                  <td className="">Monday</td>
                                  <td className="set-mob">
                                    <div className="input-append bootstrap-timepicker date-input">
                                      <input
                                        name="data[0][MerchantScheduledDay][start_time]"
                                        className="timepicker2 input-small count-unit2"
                                        value="09:00 am"
                                        type="text"
                                        id="MerchantScheduledDaymondayFrom"
                                      />
                                      <span className="add-on">
                                        <i className="fa fa-clock-o"></i>
                                      </span>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="input-append bootstrap-timepicker date-input">
                                      <input
                                        name="data[0][MerchantScheduledDay][end_time]"
                                        className="timepicker2 input-small count-unit2"
                                        value="09:00 pm"
                                        type="text"
                                        id="MerchantScheduledDaymondayTo"
                                      />
                                      <span className="add-on">
                                        <i className="fa fa-clock-o"></i>
                                      </span>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row employeeSettingSec d-flex">
                      <div className="col-md-8 d-flex">
                        <div class="shadowclass mt-0">
                          <h4 class="event-alert">Banking Info</h4>
                          <div class="inner-space screen-scroll mCS_destroyed">
                            <table
                              id="TableDable"
                              class="checklist-table remove-space"
                              cellspacing="0"
                              cellpadding="0"
                              width="100%"
                            >
                              <thead>
                                <tr>
                                  <th>Bank Name</th>
                                  <th>Account #</th>
                                  <th>Routing #</th>
                                  <th>Primary Account?</th>
                                </tr>
                              </thead>
                              <tbody id="bankingIndex"></tbody>
                            </table>
                            <div class="my-3">
                              <a
                                id="addBanking"
                                class="btn green-btn-revert add-plus"
                                href="#_"
                              >
                                <i class="i-icon"> </i> Add Account{" "}
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-4 timeSetting d-flex">
                        <div className="shadowclass mt-0">
                          <h4 class="event-alert">Documents</h4>
                          <div class="inner-space screen-scroll mCS_destroyed">
                            <table
                              id="TableDable"
                              class="checklist-table remove-space aviTable"
                              cellspacing="0"
                              cellpadding="0"
                              width="100%"
                            >
                              <tbody id="documentIndex"></tbody>
                            </table>
                            <div class="my-3">
                              <a
                                id="addDocument"
                                class="btn green-btn-revert add-plus"
                                href="#_"
                              >
                                <i class="i-icon"> </i> Add Document{" "}
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mx-0">
                  <div className="container px-0 d-flex col-12">
                    <div className="btns col-4 d-flex justify-content-end py-4 col-12">
                      <button id="cancel" type="button">
                        Cancel
                      </button>
                      <button id="" type="Submit">
                        Reset Device ID
                      </button>
                      <button id="" class="btn bordered-btn mx-3" type="Submit">
                        Apply
                      </button>
                      <button id="" className="mx-0" type="Submit">
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="tab-pane fade"
                id="nav-profile"
                role="tabpanel"
                aria-labelledby="nav-profile-tab"
              >
                <div className="row">
                  <div className="container px-0">
                    <div
                      className="accordion"
                      id="accordionPanelsStayOpenExample"
                    >
                      <div className="accordion-item">
                        <h2
                          className="accordion-header"
                          id="panelsStayOpen-headingOne"
                        >
                          <button
                            className="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#panelsStayOpen-collapseOne"
                            aria-expanded="true"
                            aria-controls="panelsStayOpen-collapseOne"
                          >
                            <div className="col d-flex align-items-center">
                              <h4 className="event-alert p-0 mb-0">Payroll</h4>
                            </div>{" "}
                          </button>
                        </h2>
                        <div
                          id="panelsStayOpen-collapseOne"
                          className="accordion-collapse collapse show"
                          aria-labelledby="panelsStayOpen-headingOne"
                        >
                          <div className="">
                            <div className="row mx-0 lab_edit_emp">
                              <div className="container px-0">
                                <div className="shadowclass mt-0">
                                  <div
                                    className="accordion"
                                    id="accordionFlushExample"
                                  >
                                    <div className="table-responsive accordion-table">
                                      <table className="checklist-table remove-space">
                                        <thead>
                                          <tr>
                                            <th width="110">Period</th>
                                            <th width="110">Status</th>
                                            <th
                                              width="100"
                                              className="text-right"
                                            >
                                              Total Wages
                                            </th>
                                            <th
                                              width="120"
                                              className="text-right"
                                            >
                                              Employee Var. Pay
                                            </th>
                                            <th
                                              width="110"
                                              className="text-right"
                                            >
                                              Employee Meals
                                            </th>
                                            <th
                                              width="110"
                                              className="text-right"
                                            >
                                              Contribution
                                            </th>
                                            <th
                                              width="80"
                                              className="text-right"
                                            >
                                              Net Pay
                                            </th>
                                            <th
                                              width="80"
                                              className="text-right"
                                            >
                                              Total Cost
                                            </th>
                                            <th width="50"></th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr class="main-tr bg-gry">
                                            <td>
                                              <strong> 2022 </strong>
                                            </td>
                                            <td> </td>
                                            <td className="align-right">
                                              <strong> $7,440.00</strong>{" "}
                                            </td>
                                            <td className="align-right">
                                              <strong> $0.00</strong>{" "}
                                            </td>
                                            <td className="align-right">
                                              <strong> $0.00</strong>{" "}
                                            </td>
                                            <td className="align-right">
                                              <strong> $0.00</strong>{" "}
                                            </td>
                                            <td className="align-right">
                                              <strong> $0.00</strong>{" "}
                                            </td>
                                            <td className="align-right">
                                              <strong> $2.00</strong>{" "}
                                            </td>
                                            <td align="center">
                                              <div className="circle_icon">
                                                <button
                                                  class="dropdown-green collapsed"
                                                  type="button"
                                                  data-bs-toggle="collapse"
                                                  data-bs-target="#flush-collapseOne"
                                                  aria-expanded="true"
                                                  aria-controls="flush-collapseOne"
                                                ></button>
                                              </div>
                                            </td>
                                          </tr>

                                          <tr
                                            id="flush-collapseOne"
                                            class="accordion-collapse show in collapse"
                                            aria-labelledby="flush-headingOne"
                                            data-bs-parent="#accordionFlushExample"
                                          >
                                            <td colspan="9" class="p-0">
                                              <table class="table">
                                                <tbody>
                                                  <tr>
                                                    <td width="110">
                                                      {" "}
                                                      2022-04-23 - 2022-05-22{" "}
                                                    </td>
                                                    <td width="110">
                                                      {" "}
                                                      <span class="purple_tag">
                                                        {" "}
                                                        Unpaid{" "}
                                                      </span>{" "}
                                                    </td>

                                                    <td
                                                      width="100"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $2,500.00{" "}
                                                    </td>
                                                    <td
                                                      width="120"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td
                                                      width="110"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td
                                                      width="110"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td
                                                      width="80"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td
                                                      width="80"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td width="40">
                                                      {" "}
                                                      <a
                                                        href="/labor_settings/view_payroll_individual/9231"
                                                        class="circle_icon"
                                                      >
                                                        <i class="iconSprites eye-icon">
                                                          {" "}
                                                        </i>
                                                      </a>{" "}
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <td width="110">
                                                      {" "}
                                                      2022-04-02 - 2022-05-01{" "}
                                                    </td>
                                                    <td width="110">
                                                      {" "}
                                                      <span class="purple_tag">
                                                        {" "}
                                                        Unpaid{" "}
                                                      </span>{" "}
                                                    </td>

                                                    <td
                                                      width="100"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td
                                                      width="120"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td
                                                      width="110"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td
                                                      width="110"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td
                                                      width="80"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td
                                                      width="80"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td width="40">
                                                      {" "}
                                                      <a
                                                        href="/labor_settings/view_payroll_individual/10019"
                                                        class="circle_icon"
                                                      >
                                                        <i class="iconSprites eye-icon">
                                                          {" "}
                                                        </i>
                                                      </a>{" "}
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <td width="110">
                                                      {" "}
                                                      2022-03-23 - 2022-04-22{" "}
                                                    </td>
                                                    <td width="110">
                                                      {" "}
                                                      <span class="purple_tag">
                                                        {" "}
                                                        Unpaid{" "}
                                                      </span>{" "}
                                                    </td>

                                                    <td
                                                      width="100"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $1,600.00{" "}
                                                    </td>
                                                    <td
                                                      width="120"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td
                                                      width="110"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td
                                                      width="110"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td
                                                      width="80"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td
                                                      width="80"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td width="40">
                                                      {" "}
                                                      <a
                                                        href="/labor_settings/view_payroll_individual/9230"
                                                        class="circle_icon"
                                                      >
                                                        <i class="iconSprites eye-icon">
                                                          {" "}
                                                        </i>
                                                      </a>{" "}
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <td width="110">
                                                      {" "}
                                                      2022-03-02 - 2022-04-01{" "}
                                                    </td>
                                                    <td width="110">
                                                      {" "}
                                                      <span class="purple_tag">
                                                        {" "}
                                                        Unpaid{" "}
                                                      </span>{" "}
                                                    </td>

                                                    <td
                                                      width="100"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td
                                                      width="120"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td
                                                      width="110"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td
                                                      width="110"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td
                                                      width="80"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td
                                                      width="80"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td width="40">
                                                      {" "}
                                                      <a
                                                        href="/labor_settings/view_payroll_individual/9955"
                                                        class="circle_icon"
                                                      >
                                                        <i class="iconSprites eye-icon">
                                                          {" "}
                                                        </i>
                                                      </a>{" "}
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <td width="110">
                                                      {" "}
                                                      2022-02-23 - 2022-03-22{" "}
                                                    </td>
                                                    <td width="110">
                                                      {" "}
                                                      <span class="purple_tag">
                                                        {" "}
                                                        Unpaid{" "}
                                                      </span>{" "}
                                                    </td>

                                                    <td
                                                      width="100"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $1,660.00{" "}
                                                    </td>
                                                    <td
                                                      width="120"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td
                                                      width="110"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td
                                                      width="110"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td
                                                      width="80"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td
                                                      width="80"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td width="40">
                                                      {" "}
                                                      <a
                                                        href="/labor_settings/view_payroll_individual/9229"
                                                        class="circle_icon"
                                                      >
                                                        <i class="iconSprites eye-icon">
                                                          {" "}
                                                        </i>
                                                      </a>{" "}
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <td width="110">
                                                      {" "}
                                                      2022-02-02 - 2022-03-01{" "}
                                                    </td>
                                                    <td width="110">
                                                      {" "}
                                                      <span class="purple_tag">
                                                        {" "}
                                                        Unpaid{" "}
                                                      </span>{" "}
                                                    </td>

                                                    <td
                                                      width="100"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td
                                                      width="120"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td
                                                      width="110"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td
                                                      width="110"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td
                                                      width="80"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td
                                                      width="80"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td width="40">
                                                      {" "}
                                                      <a
                                                        href="/labor_settings/view_payroll_individual/9873"
                                                        class="circle_icon"
                                                      >
                                                        <i class="iconSprites eye-icon">
                                                          {" "}
                                                        </i>
                                                      </a>{" "}
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <td width="110">
                                                      {" "}
                                                      2022-01-23 - 2022-02-22{" "}
                                                    </td>
                                                    <td width="110">
                                                      {" "}
                                                      <span class="purple_tag">
                                                        {" "}
                                                        Unpaid{" "}
                                                      </span>{" "}
                                                    </td>

                                                    <td
                                                      width="100"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $1,680.00{" "}
                                                    </td>
                                                    <td
                                                      width="120"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td
                                                      width="110"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td
                                                      width="110"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td
                                                      width="80"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td
                                                      width="80"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td width="40">
                                                      {" "}
                                                      <a
                                                        href="/labor_settings/view_payroll_individual/9228"
                                                        class="circle_icon"
                                                      >
                                                        <i class="iconSprites eye-icon">
                                                          {" "}
                                                        </i>
                                                      </a>{" "}
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <td width="110">
                                                      {" "}
                                                      2022-01-02 - 2022-02-01{" "}
                                                    </td>
                                                    <td width="110">
                                                      {" "}
                                                      <span class="purple_tag">
                                                        {" "}
                                                        Unpaid{" "}
                                                      </span>{" "}
                                                    </td>

                                                    <td
                                                      width="100"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td
                                                      width="120"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td
                                                      width="110"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td
                                                      width="110"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td
                                                      width="80"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td
                                                      width="80"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td width="40">
                                                      {" "}
                                                      <a
                                                        href="/labor_settings/view_payroll_individual/9247"
                                                        class="circle_icon"
                                                      >
                                                        <i class="iconSprites eye-icon">
                                                          {" "}
                                                        </i>
                                                      </a>{" "}
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <td width="110">
                                                      {" "}
                                                      2021-12-23 - 2022-01-22{" "}
                                                    </td>
                                                    <td width="110">
                                                      {" "}
                                                      <span class="green_tag">
                                                        {" "}
                                                        Paid{" "}
                                                      </span>{" "}
                                                    </td>

                                                    <td
                                                      width="100"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td
                                                      width="120"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td
                                                      width="110"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td
                                                      width="110"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td
                                                      width="80"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $0.00{" "}
                                                    </td>
                                                    <td
                                                      width="80"
                                                      className="align-right"
                                                    >
                                                      {" "}
                                                      $2.00{" "}
                                                    </td>
                                                    <td width="40">
                                                      {" "}
                                                      <a
                                                        href="/labor_settings/view_payroll_individual/9227"
                                                        class="circle_icon"
                                                      >
                                                        <i class="iconSprites eye-icon">
                                                          {" "}
                                                        </i>
                                                      </a>{" "}
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="nav-contact"
                role="tabpanel"
                aria-labelledby="nav-contact-tab"
              >
                <div className="row">
                  <div className="container px-0">
                    <div
                      className="accordion"
                      id="accordionPanelsStayOpenExample"
                    >
                      <div className="accordion-item">
                        <h2
                          className="accordion-header"
                          id="panelsStayOpen-headingOne"
                        >
                          <button
                            className="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#panelsStayOpen-collapseOne"
                            aria-expanded="true"
                            aria-controls="panelsStayOpen-collapseOne"
                          >
                            <div className="col d-flex align-items-center">
                              <h4 className="event-alert p-0 mb-0">
                                Career Events
                              </h4>
                            </div>{" "}
                          </button>
                        </h2>
                        <div
                          id="panelsStayOpen-collapseOne"
                          className="accordion-collapse collapse show"
                          aria-labelledby="panelsStayOpen-headingOne"
                        >
                          <div className="">
                            <div className="row mx-0">
                              <div className="container px-0">
                                <div className="shadowclass mt-0">
                                  <div className="table-responsive">
                                    <table className="checklist-table remove-space inventory_table">
                                      <thead>
                                        <tr>
                                          <th width="110">Account</th>
                                          <th width="110">Status</th>
                                          <th width="100">Category</th>
                                          <th width="120">Function</th>
                                          <th width="110">Role Title</th>
                                          <th width="110">Event</th>
                                          <th width="80">Pay</th>
                                          <th width="80">Effective Date</th>
                                          <th class="action-td">Action</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr class="main-tr">
                                          <td>Boat Quay Pilot</td>
                                          <td> Full Time </td>
                                          <td> Non-Executive </td>
                                          <td>Kitchen </td>
                                          <td>Line Cook</td>
                                          <td> Change Status </td>
                                          <td>$30,000.00</td>
                                          <td>May 06,2022 </td>
                                          <td
                                            align="center"
                                            className="centerAligned"
                                          >
                                            <a
                                              href="javascript:void(0)"
                                              class="circle_icon view_career_details"
                                              val="742"
                                              mtid="377"
                                            >
                                              <i class="iconSprites eye-icon">
                                                {" "}
                                              </i>
                                            </a>

                                            <a
                                              href="#_"
                                              class="circle_icon edit_tooltip"
                                              value="59"
                                            >
                                              <i class="iconSprites edit-icon"></i>
                                            </a>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                    <div className="my-3">
                                      <button
                                        className="btn green-btn-revert add-plus addSp"
                                        id="addCount"
                                        type="button"
                                      >
                                        <i className="i-icon"> </i> New Events
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="tab-pane fade"
                id="nav-mastersetting"
                role="tabpanel"
                aria-labelledby="nav-mastersetting"
              >
                <div className="row">
                  <div className="container px-0">
                    <div className="shadowclass">
                      <div className="top-header-sec d-flex justify-content-between">
                        <h4 className="event-alert mb-3 col-md-4">
                          History
                          <div className="clear"></div>
                        </h4>
                      </div>

                      <div className="row justify-content-between align-items-center">
                        <div className="col-md-4">
                          <div className="search-box mt-0">
                            <form type="GET">
                              <input
                                type="text"
                                placeholder="Search"
                                name="keyword1"
                              />
                              <input type="submit" />
                            </form>
                          </div>
                        </div>
                      </div>

                      <div className="row mx-0 my-0">
                        <div className="table-responsive px-0">
                          <table
                            id="TableDable"
                            class="checklist-table remove-space table"
                            cellspacing="0"
                            cellpadding="0"
                            width="100%"
                          >
                            <thead>
                              <tr>
                                <th>Start</th>
                                <th>End</th>
                                <th>Field</th>
                                <th>Value</th>
                                <th>Replacement Value</th>
                                <th>Updated By</th>
                                <th></th>
                                <th></th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody id="employeeHistory">
                              <tr>
                                <td width="15%">2022/01/13</td>
                                <td width="15%"></td>
                                <td width="25%">Newly created Employee</td>
                                <td width="20%">
                                  <span class="text-ellipsis"></span>
                                </td>
                                <td width="25%">
                                  <span class="text-ellipsis"></span>
                                </td>
                                <td> </td>
                                <td></td>
                                <td></td>
                                <td></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default EditEmployee;
